import * as React from "react";
import { ToastBox } from "./styles";
export interface ToastProps {
	message: string;
	width?: number;
	height?: number;
	fontSize?: number;
}
export default class Toast extends React.PureComponent<ToastProps, {}> {
	render() {
		const { message, width, height } = this.props;
		return (
			<ToastBox width={width} height={height}>
				{message}
			</ToastBox>
		);
	}
}
